import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-order-success',
  templateUrl: './order-success.component.html',
  styleUrl: './order-success.component.scss'
})
export class OrderSuccessComponent implements OnInit {
  constructor() { }

  ngOnInit(): void {
    localStorage.removeItem('couponApplied')
    localStorage.removeItem('couponValue')
    localStorage.removeItem('couponCode')
    localStorage.removeItem('couponType')
    localStorage.removeItem('couponId')
    sessionStorage.removeItem('cartItems');
    sessionStorage.removeItem('customCartItems');
  }
}
